import React from "react";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { injectIntl } from "react-intl";
import { withRouter } from "../../../../shared/hoc/withRouter";

import BiDynamicForm from "../../../../partials/layout/BiDynamicForm";
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";

import * as aiSettingsCrud from "../../../../crud/aisettings.crud";

const initialState = {
  contractAISettings: null,
  loading: true,
  saving: false,
};

class ContractAISettings extends React.Component {
  constructor(props) {
    super(props);

    this.contractAISettingsFormConfig = {
      buttonText: props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_UPDATE" }),
      fields: [
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.SUPPORT_ARTICLES" }),
          dataField: "supportarticles",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.SUPPORT_ARTICLES_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.REACHBACK_DATA" }),
          dataField: "reachbackdata",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.REACHBACK_DATA_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.SENTIMENT_ANALYSIS" }),
          dataField: "sentimentanalysis",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.SENTIMENT_ANALYSIS_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.AI_SUMMARISATION" }),
          dataField: "aisummarisation",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.AI_SUMMARISATION_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.ATTACHMENTS" }),
          dataField: "attachments",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.ATTACHMENTS_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.DOCUMENTS" }),
          dataField: "documents",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.DOCUMENTS_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.USER_UPLOADS" }),
          dataField: "useruploads",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.USER_UPLOADS_TOOLTIP" }),
          },
        },
      ],
    };

    this.state = { ...initialState };
  }

  componentDidMount() {
    this.fetchAISettings();
  }

  fetchAISettings = () => {
    const contractId = this.props.params?.contractid;

    if (!contractId) {
      this.props.enqueueSnackbar("Missing contract id in route params.", { variant: "error" });
      this.setState({ loading: false });
      return;
    }

    this.setState({ loading: true });

    aiSettingsCrud
      .GetAISettings("CONTRACT", contractId)
      .then((resp) => {
        const dto = resp?.data || {};

        const contractAISettings = {
          type: dto.type ?? "CONTRACT",
          referenceid: dto.referenceid ?? contractId,

          supportarticles: dto.supportarticles ?? false,
          reachbackdata: dto.reachbackdata ?? false,
          sentimentanalysis: dto.sentimentanalysis ?? false,
          aisummarisation: dto.aisummarisation ?? false,
          attachments: dto.attachments ?? false,
          documents: dto.documents ?? false,
          useruploads: dto.useruploads ?? false,
        };

        this.setState({ contractAISettings, loading: false });
      })
      .catch((err) => {
        this.props.enqueueSnackbar(err?.toString?.() || "Failed to load AI settings.", { variant: "error" });
        this.setState({ loading: false });
      });
  };

  saveAISettings = (aiSettings, setSubmitting) => {
    this.setState({ saving: true });

    const payload = {
      ...aiSettings,
      type: aiSettings.type || "CONTRACT",
      referenceid: aiSettings.referenceid || this.props.params.contractid,
    };

    aiSettingsCrud
      .SaveAISettings(payload)
      .then(() => {
        this.props.enqueueSnackbar(
          this.props.intl.formatMessage({ id: "AISETTINGS.UPDATE.SUCCESS" }),
          { variant: "success" }
        );


        this.fetchAISettings();

        if (setSubmitting) setSubmitting(false);
        this.setState({ saving: false });
      })
      .catch((err) => {
        this.props.enqueueSnackbar(err?.toString?.() || "Failed to save AI settings.", { variant: "error" });
        if (setSubmitting) setSubmitting(false);
        this.setState({ saving: false });
      });
  };

  render() {
    if (this.state.loading || !this.state.contractAISettings) {
      return <PortletSpinner />;
    }

    return (
      <Portlet>
        <PortletHeader title={this.props.intl.formatMessage({ id: "AISETTINGS.TITLE.CONTRACT" })} />
        <PortletBody style={{ maxWidth: 800 }}>
          <BiDynamicForm
            item={this.state.contractAISettings}
            config={this.contractAISettingsFormConfig}
            onSubmitHandler={this.saveAISettings}
            disabled={this.state.saving}
          />
        </PortletBody>
      </Portlet>
    );
  }
}

const mapStateToProps = (store) => ({
  userProfile: store.auth.userProfile,
  contract: store.contract.contract
});

export default withRouter(injectIntl(withSnackbar(connect(mapStateToProps)(ContractAISettings))));
